import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import "./MobileNavbar.css";
import { SERVICES_DROPDOWN_ITEMS } from "./ServicesDropDown";
import { INDUSTRIES_DROPDOWN_ITEMS } from "./IndustryDropdown";

const MOBILE_PAGE_LINKS = [
  { to: "/insights", label: "Insights" },
  { to: "/work", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/careers", label: "Careers" },
];

const MobileNavbar = ({ menuOpen, closeMenu, logo }) => {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown((current) => (current === name ? null : name));
  };

  const goTo = (to) => {
    if (!to) return;
    closeMenu();
    setOpenDropdown(null);
    navigate(to);
  };

  return (
    <div
      className={`navbar-mobile-root ${menuOpen ? "navbar-mobile-root--open" : ""}`}
    >
      <div className="navbar-mobile-backdrop" onClick={closeMenu} />

      <nav className="navbar-mobile-panel" id="navbar-mobile-panel">
        <div className="navbar-mobile-panel__header">
          <Link to="/" className="navbar-mobile-panel__logo" onClick={closeMenu}>
            <img src={logo} alt="logo" />
          </Link>

          <button
            type="button"
            className="navbar-mobile-close"
            aria-label="Close menu"
            onClick={closeMenu}
          >
            <IoMdClose className="navbar-mobile-close__icon" aria-hidden />
          </button>
        </div>

        <div className="navbar-mobile-panel__inner">
          <div className="mobile-dropdown">
            <div className="mobile-dropdown__header">
              <Link
                to="/services"
                className="mobile-dropdown__header-link"
                onClick={(e) => {
                  e.preventDefault();
                  goTo("/services");
                }}
              >
                Services
              </Link>
              <button
                type="button"
                className="mobile-dropdown__toggle"
                aria-expanded={openDropdown === "services"}
                aria-label="Toggle services menu"
                onClick={() => toggleDropdown("services")}
              >
                <FiChevronDown
                  className={`arrow ${openDropdown === "services" ? "rotate" : ""}`}
                />
              </button>
            </div>

            <div
              className={`mobile-dropdown__content ${
                openDropdown === "services" ? "open" : ""
              }`}
            >
              {SERVICES_DROPDOWN_ITEMS.map((item, index) => (
                <Link
                  key={index}
                  to={item.to || "/development"}
                  className="mobile-dropdown__link"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo(item.to || "/development");
                  }}
                >
                  <span className="mobile-dropdown__link-title">{item.title}</span>
                  <span className="mobile-dropdown__link-desc">{item.desc}</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="mobile-dropdown">
            <div className="mobile-dropdown__header">
              <Link
                to="/mobility"
                className="mobile-dropdown__header-link"
                onClick={(e) => {
                  e.preventDefault();
                  goTo("/mobility");
                }}
              >
                Industries
              </Link>
              <button
                type="button"
                className="mobile-dropdown__toggle"
                aria-expanded={openDropdown === "industries"}
                aria-label="Toggle industries menu"
                onClick={() => toggleDropdown("industries")}
              >
                <FiChevronDown
                  className={`arrow ${
                    openDropdown === "industries" ? "rotate" : ""
                  }`}
                />
              </button>
            </div>

            <div
              className={`mobile-dropdown__content ${
                openDropdown === "industries" ? "open" : ""
              }`}
            >
              {INDUSTRIES_DROPDOWN_ITEMS.map((item, index) => (
                <Link
                  key={index}
                  to={item.to || "/mobility"}
                  className="mobile-dropdown__link"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo(item.to || "/mobility");
                  }}
                >
                  <span className="mobile-dropdown__link-title">{item.title}</span>
                  <span className="mobile-dropdown__link-desc">{item.desc}</span>
                </Link>
              ))}
            </div>
          </div>

          {MOBILE_PAGE_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={(e) => {
                e.preventDefault();
                goTo(to);
              }}
              className={({ isActive }) =>
                `navbar-mobile-panel__link${
                  isActive ? " navbar-mobile-panel__link--active" : ""
                }`
              }
            >
              {label}
            </NavLink>
          ))}

          <Link
            to="/contact"
            className="contact-btn buttonclip contact-btn--mobile"
            onClick={(e) => {
              e.preventDefault();
              goTo("/contact");
            }}
          >
            Contact us
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default MobileNavbar;
